import skynet from './skynet';

export const $tracing = skynet;
